'use client';

import { useOverlayStore } from '@/client/stores/useOverlayMenuStore';
import { Button } from '@/components/ui/button';

export function OverlayMenuToggle() {
  const { isOpen, setIsOpen } = useOverlayStore();

  return <Button onClick={() => setIsOpen(!isOpen)}>{isOpen ? 'close' : 'menu'}</Button>;
}
